import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleDecorationType extends Cloneable {
    static NONE = new SmartOfferBundleDecorationType(0, "NONE");

    static _values = [
        new SmartOfferBundleDecorationType(1, "HALLOWEEN"),
        new SmartOfferBundleDecorationType(2, "CHRISTMAS"),
        // new SmartOfferBundleDecorationType(2, "X"),
        // new SmartOfferBundleDecorationType(3, "XX"),
        // new SmartOfferBundleDecorationType(4, "XXX"),
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferBundleDecorationType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferBundleDecorationType) {
            return SmartOfferBundleDecorationType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferBundleDecorationType.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof SmartOfferBundleDecorationType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleDecorationType());
        } else if (target instanceof SmartOfferBundleDecorationType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleDecorationType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});